export default __webpack_public_path__ + "static/media/Punto_04_Finocchietti_DEU_Def.de4a6121.aac";